import { Link } from "react-router-dom";
import constants from "../constants/constants";
import Contact from "./contact.component";
import { useCallback, useEffect, useRef, useState } from "react";

export default function Services() {
  const useScrollVisibility = () => {
    const slideRefs = useRef([]);

    const addToRefs = (el) => {
      if (el && !slideRefs.current.includes(el)) {
        slideRefs.current.push(el);
      }
    };

    const isScrolledIntoView = useCallback((elem) => {
      if (elem) {
        const rect = elem.getBoundingClientRect();
        const elemTop = rect.top;
        const elemBottom = rect.bottom;
        return elemTop >= 0 && elemBottom <= window.innerHeight;
      }
      return false;
    }, []);

    useEffect(() => {
      slideRefs.current.forEach((el) => {
        if (isScrolledIntoView(el)) {
          el?.classList.remove("slide-left");
        }
      });
    }, [isScrolledIntoView]);

    return { addToRefs };
  };

  const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState(window.innerWidth);

    const onWindowResize = useCallback(() => {
      setWindowSize(window.innerWidth);
    }, []);

    useEffect(() => {
      window.addEventListener("resize", onWindowResize);
      return () => window.removeEventListener("resize", onWindowResize);
    }, [onWindowResize]);

    return windowSize;
  };

  const windowSize = useWindowSize();

  const { addToRefs } = useScrollVisibility();

  return (
    <div className="w-full max-w-[1400px] mx-auto px-7 mb-10 min-h-[70vh] pt-[190px]">
      <h1
        ref={addToRefs}
        className={`text-3xl md:text-4xl tracking-wider font-semibold uppercase text-black pb-8 libre duration-2000 slide-in text-center my-8 ${windowSize > 700 ? "slide-left" : ""
          }`}
      >
        Services
      </h1>

      <div className="flex flex-col gap-y-24">
        {constants.SERVICES.map((service) => {
          const Icon = service.icon;
          return (
            <div class="grid grid-cols-1 lg:grid-cols-5 gap-16">
              {/* Icon box */}
              <div className="flex items-start justify-center p-4">
                <Icon className="w-28 h-28" />
              </div>
              <div class="lg:col-span-4 p-4 flex flex-col gap-10">
                <h2 className="text-4xl font-semibold tracking-wider">{service.title}</h2>
                {service.description.split("<|>").map((p) => (
                  <p className="text-xl text-black tracking-wide font-light">{p}</p>
                ))}


                < div className="space-y-6" >
                  {
                    service.items.map((item, i) => (
                      <div key={i}>
                        <h4 className="text-2xl font-semibold mb-2">{item.title}</h4>
                        <p className="text-black text-xl tracking-wide font-light">{item.text}</p>
                      </div>
                    ))
                  }
                </div>
                {service.alt_description.split("<|>").map((p) => (
                  <p className="text-xl text-black tracking-wide font-light">{p}</p>
                ))}

                {service.button && (
                  <Link
                    to={service.button.href}
                    target={service.button.label === "Discover More" ? "_blank" : ""}
                    rel="noopener noreferrer"
                    className="whitespace-nowrap text-lg uppercase tracking-wider w-fit border-2 border-logo-main hover:bg-logo-third hover:border-transparent hover:text-white hover:scale-110 duration-500 ease-in-out
                    px-5 md:px-9 py-[7px] md:py-[12px] text-logo-second font-semibold transition-all transform"
                  >
                    {service.button.label}
                  </Link>
                )}

              </div>
            </div>
          )
        })}
      </div>

      <Contact />
    </div >
  )
}